export const playCopy = {
  play_subnav_title: "Playground",
  play_subnav_config: "Playground",
  play_config_language_blurb: "Que idioma se debe usar en el editor",
  play_subnav_examples: "Ejemplos",
  play_subnav_examples_close: "Cerrar",
  play_subnav_whatsnew: "¿Qué hay de nuevo?",
  play_downloading_typescript: "Descargando TypeScript...", // when loading
  play_downloading_version: "Versión...", // when loading
  play_toolbar_run: "Ejecutar",
  play_toolbar_export: "Exportar",
  play_sidebar_js: "JS",
  play_sidebar_dts: "DTS",
  play_sidebar_errors: "Errores",
  play_sidebar_errors_no_errors: "Sin errores",
  play_sidebar_logs: "Registros",
  play_sidebar_logs_no_logs: "Sin registros",
  play_sidebar_options: "Opciones",
  play_sidebar_options_restart_required: "Reinicio requerido",
  play_sidebar_options_disable_ata: "Deshabilitar ATA",
  play_sidebar_options_disable_ata_copy:
    "Deshabilita la adquisición automática de tipos provenientes de declaraciones import y requires.",
  play_sidebar_options_disable_save: "Deshabilita el guardado automático",
  play_sidebar_options_disable_save_copy:
    "Deshabilita cambiar la URL cuando escribes.",
  play_sidebar_options_external: "Complementos externos",
  play_sidebar_options_external_warning:
    "Advertencia: Código proveniente de complementos son originarios por terceros.",
  play_sidebar_options_modules: "Módulos personalizados",
  play_sidebar_options_modules_placeholder: "Módulo proveniente de npm.",
  play_sidebar_options_plugin_dev: "Desarrollo de complementos",
  play_sidebar_options_plugin_dev_option:
    "Conectar a <code>localhost:5000/index.js</code>",
  play_sidebar_options_plugin_dev_copy:
    "Automaticamente intenta conectar a un complemento para sitio de pruebas en modo desarrollo. Puedes leer más <a href='https://www.typescriptlang.org/dev/playground-plugins/'>aquí</a>.",
  play_export_report_issue:
    "Reporta una incidencia en el repositorio GitHub de TypeScript",
  play_export_copy_md: "Copiar como una incidencia en formato Markdown",
  play_export_copy_link: "Copiar como un enlace en formato Markdown",
  play_export_copy_link_preview:
    "Copiar como un enlace en formato Markdown con vista previa",
  play_export_tsast: "Abrir en el visor AST de TypeScript",
  play_export_sandbox: "Abrir en CodeSandbox",
  play_export_stackblitz: "Abrir en StackBlitz",
  play_export_clipboard: "URL copiada al portapapeles",
  play_run_js: "JavaScript ejecutado",
  play_run_ts: "TypeScript transpilado ejecutado",
  play_run_js_fail: "Ejecución de JavaScript fallida:",
  play_default_code_sample: `// ¡Bienvenido al editor en linea de TypeScript!, este es un sitio web 
// que te brinda la oportunidad de escribir, compartir y aprender TypeScript.

// 

// Puedes pensarlo de tres maneras:
//
//  - Un sitio para aprender TypeScript de manera segura
//  - Un sitio para experimentar con la sintaxis de TypeScript y compartir tu código con otros.
//  - Un sitio para experimentar con las diferentes caracteristicas del compilador de TypeScript

const anExampleVariable = "Hello World"
console.log(anExampleVariable)

// Para aprender más acerca del lenguaje, haz click en la parte superior en "Ejemplos" o "¿Qué hay de nuevo?".
// De lo contrario, comienza eliminando estos comentarios, y el mundo es tu área de juegos!
    `,
}
